export const enum LoadState {
  Idle = 'LoadState/Idle',
  Loading = 'LoadState/Loading',
  Loaded = 'LoadState/Loaded',
  Errored = 'LoadState/Errored',
}
